module.exports = __webpack_public_path__ + "static/media/Assets-06-Books-of-type-hero.65bf6cb3.jpg";